
import RentalClubIndex from '../components/rental_clubs/RentalClubIndex.vue';
import Vue from 'vue';

Vue.component('rental-club-index', RentalClubIndex);

export default Vue.extend({});
